import queryOrders from "@api/operations/query-orders";
import { CriteriaRequest } from "@api/types/criteria";
import { OrdersPage, OrderStatus } from "@api/types/order";
import { GetServerSideProps } from "next";
import React from "react";

import Container from "@components/Container";
import MainLayout from "@components/MainLayout";
import OrderHistoryContainer from "@components/OrderHistoryContainer";

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const {
    cookies: { token },
  } = req;
  const { page = 0, size = 10 } = query;

  const request: CriteriaRequest = {
    criteria: [],
    page: parseInt(page as string),
    size: parseInt(size as string),
    sort: "orderNumber",
  };

  const result = await queryOrders({ token, request });

  return {
    props: {
      page: result.page,
      statuses: result.statuses,
    },
  };
};

export default function MyHistoryPage({ page, statuses }: { page: OrdersPage; statuses: OrderStatus[] }) {
  return (
    <Container>
      <OrderHistoryContainer page={page} statuses={statuses} />
    </Container>
  );
}

MyHistoryPage.Layout = MainLayout;
